import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_check_circle.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_eye_red.svg'
import _imports_2 from '@/app/ui/assets/svg/ellipse.svg'
import _imports_3 from '@/app/ui/assets/svg/x.svg'


const _hoisted_1 = { class: "inline-flex" }
const _hoisted_2 = { class: "flex justify-center border-b pb-6" }
const _hoisted_3 = { class: "flex justify-center items-center max-w-max" }
const _hoisted_4 = { class: "mr-4 flex items-center" }
const _hoisted_5 = {
  key: 0,
  class: "border border-red-lp-100 rounded-full text-red-lp-100 text-xs w-5 h-5 mr-2 flex items-center justify-center font-bold"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("hr", { class: "w-24 m-auto" }, null, -1)
const _hoisted_7 = { class: "ml-4 flex items-center" }
const _hoisted_8 = {
  key: 0,
  class: "pb-6"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("hr", { style: {"margin":"16px -16px"} }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("hr", { style: {"margin":"16px -16px"} }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("hr", { style: {"margin":"16px -16px"} }, null, -1)
const _hoisted_12 = {
  key: 1,
  class: "pb-6"
}
const _hoisted_13 = { class: "font-semibold text-base mb-4" }
const _hoisted_14 = {
  key: 0,
  class: "bg-gray-lp-1000 text-black-300 rounded-xl py-4 px-6 flex text-sm  text-black-300 justify-between text-left"
}
const _hoisted_15 = { class: "w-1/2 mb-2" }
const _hoisted_16 = { class: "font-semibold mr-2" }
const _hoisted_17 = { class: "mr-2" }
const _hoisted_18 = { class: "w-1/2 mb-2" }
const _hoisted_19 = { class: "font-semibold ml-2" }
const _hoisted_20 = { class: "ml-2" }
const _hoisted_21 = { class: "w-1/2 mb-2" }
const _hoisted_22 = { class: "font-semibold mr-2" }
const _hoisted_23 = { class: "mr-2" }
const _hoisted_24 = {
  key: 1,
  class: "bg-gray-lp-1000 text-black-300 rounded-xl py-4 px-6 text-sm text-left"
}
const _hoisted_25 = { class: "w-1/2 mb-3" }
const _hoisted_26 = { class: "font-semibold mb-1" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", null, "Harga normal", -1)
const _hoisted_28 = { class: "pt-2 mb-3 border-t border-gray-lp-1600 flex justify-between gap-4" }
const _hoisted_29 = { class: "w-1/2" }
const _hoisted_30 = { class: "font-semibold mb-1" }
const _hoisted_31 = { class: "break-words mb-1" }
const _hoisted_32 = {
  key: 0,
  class: "px-2 py-1 flex items-center rounded-full bg-green-lp-300 gap-1"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "check"
}, null, -1)
const _hoisted_34 = { class: "text-green-lp-400" }
const _hoisted_35 = { class: "w-1/2" }
const _hoisted_36 = { class: "font-semibold mb-1" }
const _hoisted_37 = { class: "flex items-center gap-1" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = /*#__PURE__*/_createVNode("img", {
  class: "w-4",
  src: _imports_1,
  alt: "eye"
}, null, -1)
const _hoisted_41 = { class: "font-semibold text-red-lp-1500" }
const _hoisted_42 = { class: "pt-2 mb-3 border-t border-gray-lp-1600 flex justify-between gap-4" }
const _hoisted_43 = { class: "w-full" }
const _hoisted_44 = { class: "font-semibold mb-1" }
const _hoisted_45 = { class: "diskon-body flex flex-col flex-wrap" }
const _hoisted_46 = { class: "pt-2 border-t border-gray-lp-1600 flex justify-between gap-4 mb-4" }
const _hoisted_47 = { class: "w-1/2" }
const _hoisted_48 = { class: "font-semibold mb-1" }
const _hoisted_49 = { class: "break-words" }
const _hoisted_50 = { class: "pt-2 border-t border-gray-lp-1600" }
const _hoisted_51 = { class: "w-1/2 mb-2" }
const _hoisted_52 = { class: "font-semibold mb-1" }
const _hoisted_53 = { class: "flex justify-between gap-4" }
const _hoisted_54 = { class: "w-1/2" }
const _hoisted_55 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "w-3",
    src: _imports_2,
    alt: "ellipse"
  }),
  /*#__PURE__*/_createVNode("div", { class: "w-full ml-1 border-t border-dashed border-gray-lp-1300" })
], -1)
const _hoisted_56 = { class: "font-semibold mt-2" }
const _hoisted_57 = { class: "w-1/2" }
const _hoisted_58 = /*#__PURE__*/_createVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "w-3",
    src: _imports_2,
    alt: "ellipse"
  })
], -1)
const _hoisted_59 = { class: "font-semibold mt-2" }
const _hoisted_60 = {
  key: 2,
  class: "bg-gray-lp-1000 text-black-300 rounded-xl py-4 px-6 text-sm text-left"
}
const _hoisted_61 = { class: "w-1/2 mb-2" }
const _hoisted_62 = { class: "font-semibold mb-1" }
const _hoisted_63 = { class: "break-words" }
const _hoisted_64 = { class: "pt-2 mb-2 border-t border-gray-lp-1600 flex justify-between gap-4" }
const _hoisted_65 = { class: "w-full mb-2" }
const _hoisted_66 = { class: "font-semibold mb-1" }
const _hoisted_67 = { class: "break-words" }
const _hoisted_68 = { class: "mb-2 flex justify-between gap-4" }
const _hoisted_69 = { class: "w-1/2 mb-2" }
const _hoisted_70 = { class: "font-semibold mb-1" }
const _hoisted_71 = { class: "mb-1" }
const _hoisted_72 = {
  key: 0,
  class: "px-2 py-1 flex items-center rounded-full bg-green-lp-300 gap-1"
}
const _hoisted_73 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "check"
}, null, -1)
const _hoisted_74 = { class: "text-green-lp-400" }
const _hoisted_75 = { class: "w-1/2 mb-2" }
const _hoisted_76 = { class: "font-semibold mb-1" }
const _hoisted_77 = { class: "break-words" }
const _hoisted_78 = { class: "pt-2 mb-3 border-t border-gray-lp-1600 flex justify-between gap-4" }
const _hoisted_79 = { class: "w-1/2 mb-2" }
const _hoisted_80 = { class: "font-semibold mb-1" }
const _hoisted_81 = { class: "break-words" }
const _hoisted_82 = { class: "pt-2 border-t border-gray-lp-1600" }
const _hoisted_83 = { class: "w-1/2 mb-2" }
const _hoisted_84 = { class: "font-semibold mb-1" }
const _hoisted_85 = { class: "flex justify-between gap-4" }
const _hoisted_86 = { class: "w-1/2" }
const _hoisted_87 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "w-3",
    src: _imports_2,
    alt: "ellipse"
  }),
  /*#__PURE__*/_createVNode("div", { class: "w-full ml-1 border-t border-dashed border-gray-lp-1300" })
], -1)
const _hoisted_88 = { class: "font-semibold mt-2" }
const _hoisted_89 = { class: "w-1/2" }
const _hoisted_90 = /*#__PURE__*/_createVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "w-3",
    src: _imports_2,
    alt: "ellipse"
  })
], -1)
const _hoisted_91 = { class: "font-semibold mt-2" }
const _hoisted_92 = {
  key: 3,
  class: "bg-gray-lp-1000 text-black-300 rounded-xl py-4 px-6 text-sm text-left"
}
const _hoisted_93 = { class: "w-1/2 mb-3" }
const _hoisted_94 = { class: "font-semibold mb-1" }
const _hoisted_95 = { class: "pt-2 mb-2 border-t border-gray-lp-1600 flex justify-between gap-4" }
const _hoisted_96 = { class: "w-full mb-2" }
const _hoisted_97 = { class: "font-semibold mb-1" }
const _hoisted_98 = { class: "break-words" }
const _hoisted_99 = { class: "mb-2 flex justify-between gap-4" }
const _hoisted_100 = { class: "w-1/2" }
const _hoisted_101 = { class: "font-semibold mb-1" }
const _hoisted_102 = { class: "break-words" }
const _hoisted_103 = { class: "w-1/2" }
const _hoisted_104 = { class: "font-semibold mb-1" }
const _hoisted_105 = { class: "flex items-center gap-1" }
const _hoisted_106 = { key: 0 }
const _hoisted_107 = { key: 1 }
const _hoisted_108 = /*#__PURE__*/_createVNode("img", {
  class: "w-4",
  src: _imports_1,
  alt: "eye"
}, null, -1)
const _hoisted_109 = { class: "font-semibold text-red-lp-1500" }
const _hoisted_110 = { class: "mb-2 flex justify-between gap-4" }
const _hoisted_111 = { class: "w-full" }
const _hoisted_112 = { class: "font-semibold mb-1" }
const _hoisted_113 = { class: "diskon-body flex flex-col flex-wrap" }
const _hoisted_114 = { class: "mb-2 flex justify-between gap-4" }
const _hoisted_115 = { class: "w-1/2 mb-2" }
const _hoisted_116 = { class: "font-semibold mb-1" }
const _hoisted_117 = { class: "mb-1" }
const _hoisted_118 = {
  key: 0,
  class: "px-2 py-1 flex items-center rounded-full bg-green-lp-300 gap-1"
}
const _hoisted_119 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "check"
}, null, -1)
const _hoisted_120 = { class: "text-green-lp-400" }
const _hoisted_121 = { class: "w-1/2 mb-2" }
const _hoisted_122 = { class: "font-semibold mb-1" }
const _hoisted_123 = { class: "break-words" }
const _hoisted_124 = { class: "pt-2 border-t border-gray-lp-1600 flex justify-between gap-4 mb-4" }
const _hoisted_125 = { class: "w-1/2" }
const _hoisted_126 = { class: "font-semibold mb-1" }
const _hoisted_127 = { class: "break-words" }
const _hoisted_128 = { class: "pt-2 border-t border-gray-lp-1600" }
const _hoisted_129 = { class: "w-1/2 mb-2" }
const _hoisted_130 = { class: "font-semibold mb-1" }
const _hoisted_131 = { class: "flex justify-between gap-4" }
const _hoisted_132 = { class: "w-1/2" }
const _hoisted_133 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "w-3",
    src: _imports_2,
    alt: "ellipse"
  }),
  /*#__PURE__*/_createVNode("div", { class: "w-full ml-1 border-t border-dashed border-gray-lp-1300" })
], -1)
const _hoisted_134 = { class: "font-semibold mt-2" }
const _hoisted_135 = { class: "w-1/2" }
const _hoisted_136 = /*#__PURE__*/_createVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "w-3",
    src: _imports_2,
    alt: "ellipse"
  })
], -1)
const _hoisted_137 = { class: "font-semibold mt-2" }
const _hoisted_138 = { class: "flex items-center justify-between px-4 py-3 border-b border-gray-lp-400" }
const _hoisted_139 = { class: "font-semibold text-16px text-black-lp-300" }
const _hoisted_140 = { class: "dialoig-3lc-body flex flex-col flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_CheckCircle = _resolveComponent("CheckCircle")!
  const _component_DetailClientParent = _resolveComponent("DetailClientParent")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Tax = _resolveComponent("Tax")!
  const _component_ContactInfo = _resolveComponent("ContactInfo")!
  const _component_PaymentInfo = _resolveComponent("PaymentInfo")!
  const _component_BillingInfo = _resolveComponent("BillingInfo")!
  const _component_Agreement = _resolveComponent("Agreement")!
  const _component_BankInfo = _resolveComponent("BankInfo")!
  const _component_PriceTypeForm = _resolveComponent("PriceTypeForm")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      title: _ctx.getTitle,
      "vertical-separator": false,
      "full-page": true,
      customClass: "pr-0"
    }, {
      "top-right": _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          (_ctx.isFirstStep)
            ? (_openBlock(), _createBlock(_component_button_fill, {
                key: 0,
                isDisabled: !_ctx.isFormFirstStepValid,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchStep(1))),
                title: _ctx.$t('clientManagement.registrationFlow.next'),
                class: "bg-red-lp-300 px-8"
              }, null, 8, ["isDisabled", "title"]))
            : (_openBlock(), _createBlock(_component_button_fill, {
                key: 1,
                isDisabled: !_ctx.isFormSecondStepValid,
                onClick: _ctx.onOpenSave,
                title: _ctx.$t('clientManagement.infoPriceClient.save'),
                class: "bg-red-lp-300 px-8"
              }, null, 8, ["isDisabled", "onClick", "title"]))
        ])
      ]),
      data: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              (_ctx.isFirstStep)
                ? (_openBlock(), _createBlock("div", _hoisted_5, " 1 "))
                : (_openBlock(), _createBlock(_component_CheckCircle, {
                    key: 1,
                    class: "w-6 h-6 mr-1 flex items-center justify-center check-circle-create-client-parent-red-lp-100"
                  })),
              _createVNode("div", {
                class: "cursor-pointer font-semibold text-base text-black-lp-300",
                style: {"font-size":"16px"},
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchStep(0)))
              }, _toDisplayString(_ctx.$t("clientManagement.registrationForm.parent.title")), 1)
            ]),
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _createVNode("div", {
                class: 
                `${
                  !_ctx.isFirstStep
                    ? 'border border-red-lp-100 text-red-lp-100'
                    : 'bg-gray-lp-400 text-gray-lp-600'
                } rounded-full text-xs w-5 h-5 mr-2 flex items-center justify-center font-bold`
              
              }, " 2 ", 2),
              _createVNode("div", {
                class: 
                `${
                  _ctx.isFormFirstStepValid
                    ? 'cursor-pointer'
                    : ''
                } font-semibold text-base text-black-lp-300`
              ,
                style: {"font-size":"16px"},
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isFormFirstStepValid ? _ctx.switchStep(1) : null))
              }, _toDisplayString(_ctx.$t("clientManagement.registrationFlow.priceCustomization")), 3)
            ])
          ])
        ]),
        (_ctx.isFirstStep)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode(_component_Card, {
                rounded: "xl",
                customClass: "border border-gray-lp-400 p-4 mb-6",
                isShadow: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DetailClientParent, {
                    "model-value": _ctx.form.clientParent,
                    "onUpdate:modelValue": _ctx.mergeClientParentData,
                    error: _ctx.error.clientParent,
                    isMY: _ctx.isMYDistrict,
                    managingCountryOptions: _ctx.managingCountryOptions,
                    onChangeDistrict: _ctx.onChangeDistrict
                  }, null, 8, ["model-value", "onUpdate:modelValue", "error", "isMY", "managingCountryOptions", "onChangeDistrict"])
                ]),
                _: 1
              }),
              _createVNode(_component_Card, {
                rounded: "xl",
                customClass: "border border-gray-lp-400 p-4 mb-6",
                isShadow: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Tax, {
                    modelValue: _ctx.form.tax,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.tax = $event)),
                    error: _ctx.error.tax,
                    isMY: _ctx.isMYDistrict,
                    isManagingCountryMY: _ctx.isManagingCountryMalaysia,
                    taxValidationConfig: _ctx.taxValidationConfig
                  }, null, 8, ["modelValue", "error", "isMY", "isManagingCountryMY", "taxValidationConfig"]),
                  _hoisted_9,
                  _createVNode(_component_ContactInfo, {
                    "model-value": _ctx.form.contact,
                    "onUpdate:modelValue": _ctx.mergeContactData,
                    error: _ctx.error.contact,
                    isMY: _ctx.isMYDistrict
                  }, null, 8, ["model-value", "onUpdate:modelValue", "error", "isMY"]),
                  _hoisted_10,
                  _createVNode(_component_PaymentInfo, {
                    "model-value": _ctx.form.payment,
                    isMY: _ctx.isMYDistrict
                  }, null, 8, ["model-value", "isMY"]),
                  _hoisted_11,
                  _createVNode(_component_BillingInfo, {
                    "model-value": _ctx.form.billing,
                    "onUpdate:modelValue": _ctx.mergeBillingData,
                    error: _ctx.error.billing,
                    isMY: _ctx.isMYDistrict
                  }, null, 8, ["model-value", "onUpdate:modelValue", "error", "isMY"])
                ]),
                _: 1
              }),
              _createVNode(_component_Card, {
                rounded: "xl",
                customClass: "border border-gray-lp-400 p-4 mb-6",
                isShadow: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Agreement, {
                    "model-value": _ctx.form.agreement,
                    error: _ctx.error.agreement
                  }, null, 8, ["model-value", "error"])
                ]),
                _: 1
              }),
              _createVNode(_component_Card, {
                rounded: "xl",
                customClass: "border border-gray-lp-400 p-4 mb-6",
                isShadow: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_BankInfo)
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_12, [
              _createVNode(_component_PriceTypeForm, {
                modelValue: _ctx.form,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form = $event)),
                error: _ctx.error,
                "onUpdate:error": _cache[6] || (_cache[6] = ($event: any) => (_ctx.error = $event)),
                customPriceOption: _ctx.customPriceOption,
                validateStartEndDate: _ctx.validateStartEndDate
              }, null, 8, ["modelValue", "error", "customPriceOption", "validateStartEndDate"])
            ]))
      ]),
      _: 1
    }, 8, ["onBack", "title"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: _ctx.$t('clientManagement.registrationFlow.exitPageTitle'),
      message: _ctx.$t('clientManagement.registrationFlow.exitPageMessage'),
      image: "are-you-sure",
      textSuccess: _ctx.$t('clientManagement.registrationFlow.exit'),
      textCancel: _ctx.$t('clientManagement.infoPriceClient.back'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.isAddTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx._onAdd,
      onClose: _ctx.onCloseSave,
      title: "",
      message: _ctx.customConfirmMesage,
      image: "badge-confirmation-general",
      textSuccess: _ctx.$t('clientManagement.registrationFlow.yesRegister'),
      textCancel: _ctx.$t('clientManagement.infoPriceClient.cancel'),
      class: "px-8",
      customWidth: "515px"
    }, {
      custom: _withCtx(() => [
        _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('clientManagement.registrationFlow.parentRegisterConfirmationTitle')), 1),
        (_ctx.form.isCustomRate === 'retail')
          ? (_openBlock(), _createBlock("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.pricePeriod')), 1),
                _createVNode("div", _hoisted_17, _toDisplayString(_ctx.periodeHarga || '-'), 1)
              ]),
              _createVNode("div", _hoisted_18, [
                _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.price')), 1),
                _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.priceRetail')), 1)
              ]),
              _createVNode("div", _hoisted_21, [
                _createVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.insuranceCalculation')), 1),
                _createVNode("div", _hoisted_23, _toDisplayString(_ctx.form.isInsurance ? _ctx.form.insurance === 'custom-rates' ? 'Custom Rates 0,' + _ctx.form.customRates + '%' : 'Free' : 'Retail (Tiering)'), 1)
              ])
            ]))
          : (_ctx.form.isCustomRate === 'normal')
            ? (_openBlock(), _createBlock("div", _hoisted_24, [
                _createVNode("div", _hoisted_25, [
                  _createVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('clientManagement.renewalRateCard.priceCustomizationType')), 1),
                  _hoisted_27
                ]),
                _createVNode("div", _hoisted_28, [
                  _createVNode("div", _hoisted_29, [
                    _createVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.priceNormal')), 1),
                    _createVNode("div", _hoisted_31, _toDisplayString(_ctx.form.versionBasic?.rateVersionName), 1),
                    (_ctx.form.retailBasedDistrict)
                      ? (_openBlock(), _createBlock("div", _hoisted_32, [
                          _hoisted_33,
                          _createVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.districtRetailPrice')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_35, [
                    _createVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.origin3lc')), 1),
                    _createVNode("div", _hoisted_37, [
                      (_ctx.form.originCities?.length > 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_38, _toDisplayString(_ctx.form.originCities?.length || 0), 1))
                        : (_openBlock(), _createBlock("span", _hoisted_39, _toDisplayString(_ctx.form.originCities[0].name), 1)),
                      (_ctx.form.originCities.length > 1)
                        ? (_openBlock(), _createBlock("div", {
                            key: 2,
                            class: "flex gap-1 cursor-pointer",
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.setIsOpen3LC && _ctx.setIsOpen3LC(...args)))
                          }, [
                            _hoisted_40,
                            _createVNode("span", _hoisted_41, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.seeAll')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_42, [
                  _createVNode("div", _hoisted_43, [
                    _createVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.discount')), 1),
                    _createVNode("div", _hoisted_45, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.form.discount, (discountItem, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: `discount-item-${index}`,
                          class: "w-1/2 mr-4 flex justify-between"
                        }, [
                          _createVNode("div", null, _toDisplayString(`${discountItem.product.name === 'SEMUA' ? '' : '•'} ${discountItem.product.name}`), 1),
                          _createVNode("div", null, _toDisplayString(discountItem.discount) + "% ", 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_46, [
                  _createVNode("div", _hoisted_47, [
                    _createVNode("div", _hoisted_48, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.insuranceCalculation')), 1),
                    _createVNode("div", _hoisted_49, _toDisplayString(_ctx.form.isInsurance ? _ctx.form.insurance === 'custom-rates' ? 'Custom Rates 0,' + _ctx.form.customRates + '%' : 'Free' : 'Retail (Tiering)'), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_50, [
                  _createVNode("div", _hoisted_51, [
                    _createVNode("div", _hoisted_52, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.pricePeriod')), 1)
                  ]),
                  _createVNode("div", _hoisted_53, [
                    _createVNode("div", _hoisted_54, [
                      _hoisted_55,
                      _createVNode("div", _hoisted_56, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.startDate')), 1),
                      _createVNode("div", null, _toDisplayString(_ctx.formatDate(_ctx.form.priceRateStartDate)), 1)
                    ]),
                    _createVNode("div", _hoisted_57, [
                      _hoisted_58,
                      _createVNode("div", _hoisted_59, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.endDate')), 1),
                      _createVNode("div", null, _toDisplayString(_ctx.formatDate(_ctx.form.priceRateEndDate)), 1)
                    ])
                  ])
                ])
              ]))
            : (_ctx.form.isCustomRate === 'khusus')
              ? (_openBlock(), _createBlock("div", _hoisted_60, [
                  _createVNode("div", _hoisted_61, [
                    _createVNode("div", _hoisted_62, _toDisplayString(_ctx.$t('clientManagement.renewalRateCard.priceCustomizationType')), 1),
                    _createVNode("div", _hoisted_63, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.customPrice')), 1)
                  ]),
                  _createVNode("div", _hoisted_64, [
                    _createVNode("div", _hoisted_65, [
                      _createVNode("div", _hoisted_66, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.customPriceName')), 1),
                      _createVNode("div", _hoisted_67, _toDisplayString(_ctx.form.versionName), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_68, [
                    _createVNode("div", _hoisted_69, [
                      _createVNode("div", _hoisted_70, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.price')), 1),
                      _createVNode("div", _hoisted_71, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.uploaded')), 1),
                      (_ctx.form.retailBasedDistrict)
                        ? (_openBlock(), _createBlock("div", _hoisted_72, [
                            _hoisted_73,
                            _createVNode("div", _hoisted_74, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.districtRetailPrice')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_75, [
                      _createVNode("div", _hoisted_76, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.customPrice')), 1),
                      _createVNode("div", _hoisted_77, _toDisplayString(_ctx.form.archiveFile.name), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_78, [
                    _createVNode("div", _hoisted_79, [
                      _createVNode("div", _hoisted_80, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.insuranceCalculation')), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.form.insurance) + " ", 1),
                      _createVNode("div", _hoisted_81, _toDisplayString(_ctx.form.isInsurance ? _ctx.form.insurance === 'custom-rates' ? 'Custom Rates 0,' + _ctx.form.customRates + '%' : 'Free' : 'Retail (Tiering)'), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_82, [
                    _createVNode("div", _hoisted_83, [
                      _createVNode("div", _hoisted_84, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.pricePeriod')), 1)
                    ]),
                    _createVNode("div", _hoisted_85, [
                      _createVNode("div", _hoisted_86, [
                        _hoisted_87,
                        _createVNode("div", _hoisted_88, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.startDate')), 1),
                        _createVNode("div", null, _toDisplayString(_ctx.formatDate(_ctx.form.priceRateStartDate)), 1)
                      ]),
                      _createVNode("div", _hoisted_89, [
                        _hoisted_90,
                        _createVNode("div", _hoisted_91, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.endDate')), 1),
                        _createVNode("div", null, _toDisplayString(_ctx.formatDate(_ctx.form.priceRateEndDate)), 1)
                      ])
                    ])
                  ])
                ]))
              : (_ctx.form.isCustomRate === 'kombinasi')
                ? (_openBlock(), _createBlock("div", _hoisted_92, [
                    _createVNode("div", _hoisted_93, [
                      _createVNode("div", _hoisted_94, _toDisplayString(_ctx.$t('clientManagement.renewalRateCard.priceCustomizationType')), 1),
                      _createVNode("div", null, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.priceCombination')), 1)
                    ]),
                    _createVNode("div", _hoisted_95, [
                      _createVNode("div", _hoisted_96, [
                        _createVNode("div", _hoisted_97, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.customPriceName')), 1),
                        _createVNode("div", _hoisted_98, _toDisplayString(_ctx.form.versionName), 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_99, [
                      _createVNode("div", _hoisted_100, [
                        _createVNode("div", _hoisted_101, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.priceNormal')), 1),
                        _createVNode("div", _hoisted_102, _toDisplayString(_ctx.form.versionBasic?.rateVersionName), 1)
                      ]),
                      _createVNode("div", _hoisted_103, [
                        _createVNode("div", _hoisted_104, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.origin3lc')), 1),
                        _createVNode("div", _hoisted_105, [
                          (_ctx.form.originCities?.length > 1)
                            ? (_openBlock(), _createBlock("span", _hoisted_106, _toDisplayString(_ctx.form.originCities?.length || 0), 1))
                            : (_openBlock(), _createBlock("span", _hoisted_107, _toDisplayString(_ctx.form.originCities[0].name), 1)),
                          (_ctx.form.originCities.length > 1)
                            ? (_openBlock(), _createBlock("div", {
                                key: 2,
                                class: "flex gap-1 cursor-pointer",
                                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.setIsOpen3LC && _ctx.setIsOpen3LC(...args)))
                              }, [
                                _hoisted_108,
                                _createVNode("span", _hoisted_109, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.seeAll')), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_110, [
                      _createVNode("div", _hoisted_111, [
                        _createVNode("div", _hoisted_112, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.discount')), 1),
                        _createVNode("div", _hoisted_113, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.form.discount, (discountItem, index) => {
                            return (_openBlock(), _createBlock("div", {
                              key: `discount-item-${index}`,
                              class: "w-1/2 mr-4 flex justify-between"
                            }, [
                              _createVNode("div", null, _toDisplayString(`${discountItem.product.name === 'SEMUA' ? '' : '• '}${discountItem.product.name}`), 1),
                              _createVNode("div", null, _toDisplayString(discountItem.discount) + "% ", 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_114, [
                      _createVNode("div", _hoisted_115, [
                        _createVNode("div", _hoisted_116, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.price')), 1),
                        _createVNode("div", _hoisted_117, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.uploaded')), 1),
                        (_ctx.form.retailBasedDistrict)
                          ? (_openBlock(), _createBlock("div", _hoisted_118, [
                              _hoisted_119,
                              _createVNode("div", _hoisted_120, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.districtRetailPrice')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode("div", _hoisted_121, [
                        _createVNode("div", _hoisted_122, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.customPrice')), 1),
                        _createVNode("div", _hoisted_123, _toDisplayString(_ctx.form.archiveFile.name), 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_124, [
                      _createVNode("div", _hoisted_125, [
                        _createVNode("div", _hoisted_126, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.insuranceCalculation')), 1),
                        _createVNode("div", _hoisted_127, _toDisplayString(_ctx.form.isInsurance ? _ctx.form.insurance === 'custom-rates' ? 'Custom Rates 0,' + _ctx.form.customRates + '%' : 'Free' : 'Retail (Tiering)'), 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_128, [
                      _createVNode("div", _hoisted_129, [
                        _createVNode("div", _hoisted_130, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.pricePeriod')), 1)
                      ]),
                      _createVNode("div", _hoisted_131, [
                        _createVNode("div", _hoisted_132, [
                          _hoisted_133,
                          _createVNode("div", _hoisted_134, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.startDate')), 1),
                          _createVNode("div", null, _toDisplayString(_ctx.formatDate(_ctx.form.priceRateStartDate)), 1)
                        ]),
                        _createVNode("div", _hoisted_135, [
                          _hoisted_136,
                          _createVNode("div", _hoisted_137, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.endDate')), 1),
                          _createVNode("div", null, _toDisplayString(_ctx.formatDate(_ctx.form.priceRateEndDate)), 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onSubmit", "onClose", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openSave]
    ]),
    _createVNode(_component_Dialog, {
      modelValue: _ctx.isOpen3LC,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.isOpen3LC = $event)),
      persistent: "",
      customWidth: "dialog-3lc"
    }, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_138, [
          _createVNode("p", _hoisted_139, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.origin3lc')), 1),
          _createVNode("img", {
            src: _imports_3,
            class: "w-6 h-6 cursor-pointer",
            alt: "close",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.setIsClose3LC && _ctx.setIsClose3LC(...args)))
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode("div", _hoisted_140, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.form.originCities, (originItem) => {
            return (_openBlock(), _createBlock("div", {
              key: `3lc-item-${originItem.id}`
            }, _toDisplayString(originItem.name), 1))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.goBack,
      title: _ctx.$t('clientManagement.registrationFlow.creationFailed'),
      message: 
      _ctx.$t('clientManagement.registrationFlow.invalidCustomRatesFileMessage')
    ,
      image: "image-modal-failed",
      textSuccess: _ctx.$t('clientManagement.registrationFlow.ok'),
      class: "px-8"
    }, null, 8, ["onSubmit", "title", "message", "textSuccess"]), [
      [_vShow, _ctx.isErrorDocument]
    ])
  ], 64))
}